import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Quote, Sparkles } from 'lucide-react';

export const MotivationalQuote = () => {
  const [currentQuote, setCurrentQuote] = useState(0);

  const quotes = [
    {
      text: "Der beste Kauf ist der, den du nicht machst.",
      author: "KaufPause Weisheit"
    },
    {
      text: "Zwischen Impuls und Kauf liegt die Weisheit.",
      author: "Unbekannt"
    },
    {
      text: "Reichtum besteht nicht im Besitz, sondern im Genuss.",
      author: "Aristoteles"
    },
    {
      text: "Wer Steuerersparnisse als Kaufgrund sieht, kauft mit 70% Rabatt auf sein eigenes Geld.",
      author: "Freelancer-Wahrheit"
    },
    {
      text: "30 Tage können den Unterschied zwischen Want und Need offenbaren.",
      author: "KaufPause Philosophy"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentQuote((prev) => (prev + 1) % quotes.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [quotes.length]);

  return (
    <div className="max-w-3xl mx-auto">
      <Card className="bg-white/80 border-emerald-200 shadow-sm overflow-hidden relative">
        <CardContent className="p-6 text-center relative">
          <div className="absolute top-3 left-3 text-emerald-400">
            <Quote className="w-5 h-5" />
          </div>
          
          <div className="transition-all duration-1000 mt-2">
            <blockquote className="text-lg italic text-emerald-700 mb-3 transition-all duration-500 min-h-[4.5rem] flex items-center justify-center font-medium leading-relaxed">
              "{quotes[currentQuote].text}"
            </blockquote>
            <cite className="text-sm text-emerald-600 transition-all duration-500 block min-h-[1.5rem] flex items-center justify-center">
              — {quotes[currentQuote].author}
            </cite>
          </div>
          
          <div className="flex justify-center mt-4 space-x-1">
            {quotes.map((_, index) => (
              <div
                key={index}
                className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
                  index === currentQuote ? 'bg-emerald-600' : 'bg-emerald-300'
                }`}
              />
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
